/**
 * Client module access configuration.
 * Maps clientId → list of enabled platform module IDs.
 *
 * This is the source of truth for which modules each client can access.
 * When a client has only 1 module, the PlatformHeader hides the module switcher dropdown.
 *
 * Future: this config can be replaced by a backend/session attribute (e.g. Cognito custom:modules).
 */
const CLIENT_MODULES: Record<string, string[]> = {
  MACRO: ['asset-multiplier', 'digital-brand-ambassador'],
  TEST: ['asset-multiplier', 'digital-brand-ambassador'],
  DISNEY: ['asset-multiplier'],
  GPOVALLAS: ['asset-multiplier'],
  GVAZ: ['asset-multiplier'],
  RESUMIDO: ['asset-multiplier'],
  HIPOTECARIO: ['asset-multiplier']
};

const DEFAULT_MODULES = ['asset-multiplier'];

/**
 * Returns the list of platform module IDs enabled for the given clientId.
 * Falls back to DEFAULT_MODULES for unknown clients.
 */
export const getClientModules = (clientId?: string): string[] => {
  if (!clientId) return DEFAULT_MODULES;
  return CLIENT_MODULES[clientId] ?? DEFAULT_MODULES;
};
